import React, { useRef, useState } from 'react'

import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { selectIsElectron } from '@selectors'

import { Elastic, gsap } from 'gsap'

import { IconInline, Image, Video } from '@omnilert/components'
import ImageViewer from '../image-viewer/image-viewer'
import Icon from '@components/icon/icon.component'

import { FILE_MODAL_OPEN } from '@redux/actions/types'

import {
  SCREEN_TITLE_TIP_LOCATION,
  SCREEN_TITLE_TIP_ATTACHMENT
} from '@assets/i18n/strings'

import i18n from 'i18n-js'
import useStyles from './tip-confirmation-v2.style'

const TipConfirmationV2 = (props) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const classes = useStyles({ isExpanded })

  const dispatch = useDispatch()

  const isElectron = useSelector(selectIsElectron)

  const { message } = props
  const { anonymous, header, location, text, media } = message

  const title = `${anonymous ? 'Anonymous ' : ''}${header} tip report`

  const onClickLocation = () => {
    const url = `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`

    const win = window.open(url, '_blank')

    if (!isElectron) {
      win.focus()
    }
  }


  const filesRef = useRef(null)

  const handleOnClickFiles = () => {
    setIsExpanded((prev) => !prev)

    const ease = Elastic.easeOut.config(1, 0.75)

    if (isExpanded) {
      gsap.to(filesRef.current,
        {
          duration: 0.2,
          height: 0
        })
    } else {
      gsap.fromTo(
        filesRef.current,
        { height: 0 },
        {
          duration: 0.75,
          height: 'auto',
          ease
        }
      )
    }
  }

  const handleSetFilesModal = (expandedFile) => {
    dispatch({
      type: FILE_MODAL_OPEN,
      payload: { expandedFile, cardMediaFiles: media.data }
    })
  }

  return (
    <div>
      <div className={classes.reportHeader}>
        <span className={classes.headerText}>{title}</span>
      </div>
      <div className={classes.reportBody}>
        <span>{text}</span>
      </div>
      {(location || media) && (
        <div className={classes.reportFooter}>
          {location && (
            <button
              className={classes.button}
              onClick={onClickLocation}
            >
              <span className={classes.buttonText}>
                {i18n.t(SCREEN_TITLE_TIP_LOCATION)}
              </span>
              <Icon type='pin-small' />
            </button>
          )}
          {media && (
            <button
              className={classes.button}
              onClick={handleOnClickFiles}
              style={{ marginLeft: media && location ? '5px' : '0' }}
            >
              <span className={classes.buttonText}>
                {i18n.t(SCREEN_TITLE_TIP_ATTACHMENT)}
              </span>
              <IconInline
                className={classes.icon}
                name='attachment'
                size={20}
              />
            </button>
          )}
        </div>
      )}
      {media && (
        <div
          ref={filesRef}
          className={classes.files}
        >
          {media?.map((datum, i) => {
            switch (datum.type) {
            case 'image':
              return (
                <div
                  key={i}
                  className={classes.imageContainer}
                >
                  <ImageViewer>
                    <Image
                      className={classes.image}
                      src={datum.url}
                    />
                  </ImageViewer>
                </div>
              )
            case 'video':
              return (
                <div
                  key={i}
                  className={classes.videoContainer}
                  onClick={() => handleSetFilesModal(datum)}
                >
                  <Video
                    className={classes.video}
                    controls={false}
                    media={datum}
                  />
                </div>
              )
            default:
              return null
            }
          })}
        </div>
      )}
    </div>
  )
}

TipConfirmationV2.propTypes = {
  message: PropTypes.shape({
    anonymous: PropTypes.bool,
    category: PropTypes.string,
    location: PropTypes.shape({
      latitude: PropTypes.number,
      longtitude: PropTypes.number
    }),
    text: PropTypes.string
  }).isRequired
}

export default TipConfirmationV2
